<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="js">
import { useAutonodeStore } from '@/stores/waitingAutonode.store';
import { storeToRefs } from 'pinia';
import { useNodeStore } from '@/stores/node.store';
import useModal from '@/stores/modal.store';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import ReturnModal from '@/components/modals/WaitingAutonode/ReturnModal.vue';
import { computed } from 'vue';
import _ from 'lodash';

const nodeStore = useNodeStore();
const autonodeStore = useAutonodeStore();
const { custom_variables, return_values, selectedReturnIndex, return_variable, return_message } =
  storeToRefs(autonodeStore);
const { activeModal, closeModal } = useModal();

const returnVarExists = computed(() => {
  return !!custom_variables.value.find((c) => c.name == return_variable.value);
});

function getReturnBpNodeName(returnBpNodeId) {
  return (
    nodeStore.bpNode.returns?.find((r) => r.id === returnBpNodeId)?.return_bp_node?.current?.node
      ?.name || 'Узел не найден'
  );
}

function openUpdateModal(index) {
  selectedReturnIndex.value = index;
  activeModal.value = 'ReturnModal';
}

function openDeleteModal(index) {
  selectedReturnIndex.value = index;
  activeModal.value = 'deleteModal';
}

function deleteDirection() {
  return_values.value = _.omit(return_values.value, selectedReturnIndex.value);
  closeModal();
}
</script>

<template>
  <div class="autoform-variables">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center justify-content-between w-75">
        <label for="return-var">Условие:</label>
        <select class="form-select w-25" v-model="return_variable" id="return-var">
          <template v-for="cvar in custom_variables" :key="cvar.name">
            <option
              :value="cvar.name"
              v-if="['text', 'double', 'identificator', 'boolean'].includes(cvar.type)"
            >
              {{ cvar.title }}
            </option>
          </template>
        </select>
        <label for="return-message">Сообщение:</label>
        <select class="form-select w-25" v-model="return_message" id="return-message">
          <template v-for="cvar in custom_variables" :key="cvar.name">
            <option
              :value="cvar.name"
              v-if="cvar.type == 'text'"
            >
              {{ cvar.title }}
            </option>
          </template>
        </select>
      </div>

      <div
        v-if="return_variable && return_message && returnVarExists"
        class="add-btn"
        @click="activeModal = 'ReturnModal'"
      >
        <img src="@/assets/img/plus-ico.svg" alt="plus-ico.svg" />
        Добавить возврат
      </div>
    </div>

    <div class="table-responsive">
      <table class="table gray-table">
        <thead>
          <tr>
            <th>Сравниваемое значение</th>
            <th>Возврат</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(bpNodeReturnId, value) in return_values" :key="value">
            <td>
              {{ value }}
            </td>
            <td>
              {{ getReturnBpNodeName(bpNodeReturnId) }}
            </td>
            <td>
              <div class="table-buttons">
                <div class="table-button" @click="openUpdateModal(value)">
                  <span class="edit-ico" />
                </div>
                <div class="table-button" @click="openDeleteModal(value)">
                  <span class="delite-ico" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <DeleteModal
    v-if="activeModal === 'deleteModal'"
    :itemText="'этот возврат'"
    @confirmDelete="deleteDirection()"
  />
  <ReturnModal v-if="activeModal === 'ReturnModal'" />
</template>
